<template>
  <div
    class="header-container"
    :class="{mobile, unauth: !authorized}"
  >
    <MobileHeaderDropdown
      v-if="mobile && mobileDropdownOpened"
      ref="mhd"
      :style="{
        'background-color': appHeaderBgColor ? `#${appHeaderBgColor}` : '',
      }"
      @close="mobileDropdownOpened = false"
    >
      <div class="fy-mh-mobile-companies">
        <FygrInput
          v-model="searchCompany"
          class="fy-mh-mobile-companies-search"
          icon="search"
          placeholder="Recherche une entité..."
          :value-in="searchCompany"
          clear
          no-prompt
        />
        <div
          class="fy-mh-mobile-company-list"
          :class="{
            'no-adder':
              isCpaUser(activeUser) && !permissions.cpap_create_managed_company,
          }"
        >
          <div
            v-for="company in listOfCompanies"
            :key="`fy-cmp-mobile-${company.id}`"
            class="fy-mh-mobile-company"
          >
            <div
              class="fy-mh-mobile-company-name clickable"
              :class="{active: company.id === companyId}"
              @click="
                company.companyCustom
                  ? switchCompany(company.id, $route.name, 'console')
                  : switchCompany(company.id, $route.name)
              "
            >
              <i
                v-if="company.companyCustom"
                class="fi fi-firm"
              />
              {{ company.name }}
            </div>
            <div class="fy-mh-mobile-company-separator" />
          </div>
        </div>
        <div
          v-if="
            !isCpaUser(activeUser) || permissions.cpap_create_managed_company
          "
          class="fy-mh-mobile-company-adder clickable translate"
          @click="localShowCreateCompany"
        >
          <FontAwesomeIcon icon="plus" />
          <span>{{
            isCpaUser(activeUser)
              ? 'Ajouter un dossier'
              : 'Ajouter une entreprise'
          }}</span>
        </div>
      </div>
    </MobileHeaderDropdown>
    <MobileHeaderDropdown
      v-if="mobile && menuShown && authorized"
      ref="mhdmenu"
      :style="{
        'background-color': appHeaderBgColor ? `#${appHeaderBgColor}` : '',
      }"
      @close="menuShown = false"
    >
      <div class="fy-mh-mobile-companies translate">
        <div class="fy-mh-mobile-company">
          <div
            class="fy-mh-mobile-company-name clickable"
            :class="{active: $route.name === 'dashboard'}"
            @click="
              $route.name === 'dashboard'
                ? () => true
                : $router.push('/dashboard');
              $refs.mhdmenu.close();
            "
          >
            Dashboard
          </div>
          <div class="fy-mh-mobile-company-separator" />
        </div>
        <div class="fy-mh-mobile-company">
          <div
            class="fy-mh-mobile-company-name clickable"
            :class="{active: $route.name === 'transactions'}"
            @click="
              $route.name === 'transactions'
                ? () => true
                : $router.push('/transactions');
              $refs.mhdmenu.close();
            "
          >
            Transactions
          </div>
          <div class="fy-mh-mobile-company-separator" />
        </div>
        <div class="fy-mh-mobile-company">
          <div
            class="fy-mh-mobile-company-name clickable"
            :class="{active: $route.name === 'users'}"
            @click="
              $route.name === 'users' ? () => true : $router.push('/users');
              $refs.mhdmenu ? $refs.mhdmenu.close() : () => true;
            "
          >
            Mes utilisateurs
          </div>
          <div class="fy-mh-mobile-company-separator" />
        </div>
        <div class="fy-mh-mobile-company">
          <div
            class="fy-mh-mobile-company-name clickable"
            @click="openChat"
          >
            Assistance
          </div>
          <div class="fy-mh-mobile-company-separator" />
        </div>
        <div class="fy-mh-mobile-company">
          <div
            class="fy-mh-mobile-company-name clickable red"
            @mousedown="actionLogout"
          >
            Déconnexion
          </div>
        </div>
      </div>
    </MobileHeaderDropdown>
    <CategoriesDropdownRectangle
      v-if="selectingUser"
      class="users-dd"
      placeholder="Ex : john@mail.com"
      :event-container="selectingUser"
      :list="displayedUsers"
      :min-search-length="5"
      :presearch="userEmail"
      :exclude-translation="true"
      disable-adding
      no-bg
      variable
      @close="selectingUser = null"
      @filter="getFilteredUsers"
      @select="pretendUser"
    />
    <div
      v-if="bubbleShown"
      class="speech-bubble text-gray"
      :style="{
        top: bubbleTop + 'px',
        left: bubbleLeft + 5 + 'px',
      }"
    >
      <span class="translate">Rafraichir les données bancaires</span>
    </div>
    <div
      id="nav"
      :style="{
        'background-color': appHeaderBgColor ? `#${appHeaderBgColor}` : '',
      }"
      class="header"
      :class="{mobile, unauth: !authorized}"
    >
      <div
        class="logo"
        :class="{
          small: !checkNotAuthenticatedPages($route.name),
          mobile,
          unauth: !authorized,
          appLogo: appLogo,
        }"
      >
        <a
          class="router-link-active"
          :href="isCompanyCpa ? '/console' : '/'"
        >
          <img
            v-if="appLogo"
            :src="appLogo"
            :class="{'max-height-logo': appLogo}"
          />
          <img
            v-else
            class="fy-mh-fygr-logo"
            :class="{unauth: !authorized}"
            src="@/assets/fygr_logo.svg"
          />
        </a>
      </div>
      <div
        v-if="mobile && !checkNotAuthenticatedPages($route.name)"
        class="fy-mh-menu mobile"
      >
        <div
          class="fy-mh-mobile-company-picker clickable"
          :class="{opened: mobileDropdownOpened}"
          @click="
            () => {
              if (mobileDropdownOpened) {
                $refs.mhd.close();
              } else {
                if (menuShown) {
                  $refs.mhdmenu.close();
                }
                mobileDropdownOpened = !mobileDropdownOpened;
              }
            }
          "
        >
          <span class="fy-mh-mobile-company-picker-text">
            {{ currentCompany[0] }}
          </span>
          <FontAwesomeIcon icon="caret-down" />
        </div>
        <div
          v-show="
            isActiveForCurrentCompany ||
            !companyList ||
            !Object.entries(companyList).length
          "
          :style="dynamicLinkStyle"
          :class="{
            'fy-mh-item': true,
            clickable: true,
            mobile: true,
            'router-link-active': menuActive,
            disabled: !authorized,
          }"
          @mousedown="
            mobile && menuActive ? $refs.mhdmenu.close() : showPopup()
          "
        >
          <div class="user-btn clickable white">
            <i class="fi-people" />
          </div>
        </div>
      </div>
      <div
        v-else-if="!checkNotAuthenticatedPages($route.name)"
        class="fy-mh-menu"
      >
        <button
          v-if="
            displayedTrialButton &&
            subscription.partner !== 'henrri' &&
            subscription.free_trial_version === 0
          "
          ref="trial"
          class="trial-button clickable hovarable not-translate"
          @click="showHideTrialLayoutAction"
        >
          {{ subscribeText }}
          <span
            v-if="subscription && !subscription.default && smallTrialButton"
          >
            {{ ` / J-${remainingDays}` }}
          </span>
          <span
            v-else-if="subscription && !subscription.default"
            class="remainings"
          >
            <br />{{ `${remainingDays} ${remainingDaysText}` }}
          </span>
        </button>
        <button
          v-else-if="
            isActiveForCurrentCompany &&
            endTrialPeriodButtonVisibility &&
            (isStandalone || isCpaUser(activeUser)) &&
            subscription.free_trial_version === 0
          "
          class="trial-button"
        >
          <span class="translate">Essai terminé</span>
        </button>
        <div
          v-if="checkRole(user, sales_gr)"
          class="drop-top clickable"
          :class="!!userEmail ? '' : 'user'"
          :title="userEmail"
          @click="startSelectingUser"
        >
          <span class="short-name not-translate">
            {{ userEmail || 'Ex : john@mail.com' }}
          </span>
          <FontAwesomeIcon
            :class="{open: !!selectingUser}"
            icon="caret-down"
          />
        </div>
        <div
          class="drop-top clickable"
          :title="currentCompany[0]"
          @click="openDropdown"
        >
          <span class="short-name not-translate">
            {{ currentCompany[0] }}
          </span>
          <FontAwesomeIcon
            :class="{open: !!companiesDD}"
            icon="caret-down"
          />
        </div>
        <FontAwesomeIcon
          v-if="!hideLinks && !isCompanyCpa"
          v-show="isActiveForCurrentCompany && bankConnections"
          :style="dynamicLinkStyle"
          class="sync"
          :class="{
            spinning: reloading,
            clickable: banks && banks.length && !reloading,
          }"
          icon="sync-alt"
          @click="reloadTransactions"
          @mouseenter="(e) => showBubble(e, true, 13)"
          @mouseleave="(e) => showBubble(e, false, 13)"
        />
        <router-link
          v-if="
            isActiveForCurrentCompany &&
            (permissions.basic_info ||
              permissions.view_forecast ||
              permissions.edit_forecast) &&
            !hideLinks
          "
          to="/dashboard"
          :style="dynamicLinkStyle"
          data-id="dashboard"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('dashboard')"
        >
          <span>Dashboard</span>
          <div class="fallback">Dashboard</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="
            isActiveForCurrentCompany &&
            !isCompanyCpa &&
            (permissions.basic_info ||
              permissions.view_forecast ||
              permissions.edit_forecast)
          "
          to="/analytics"
          data-id="analytics"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('analytics')"
        >
          <span>Graphiques</span>
          <div class="fallback">Graphiques</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="
            invoicesAllowed && permissions.invoices_page_access && !hideLinks
          "
          to="/invoices"
          :style="dynamicLinkStyle"
          data-id="invoices"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('invoices')"
        >
          <span> Echéances </span>
          <div class="fallback">Echéances</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="
            checksAllowed &&
            (permissions.view_forecast || permissions.edit_forecast) &&
            !hideLinks
          "
          to="/checks"
          :style="dynamicLinkStyle"
          data-id="checks"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('checks')"
        >
          <span> Chèques </span>
          <div class="fallback">Chèques</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="
            isActiveForCurrentCompany &&
            (permissions.transactions_info ||
              permissions.allow_classification) &&
            !hideLinks
          "
          to="/transactions"
          data-id="transactions"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('transactions')"
        >
          <span> Transactions </span>
          <div class="fallback">Transactions</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="
            isActiveForCurrentCompany &&
            permissions.edit_categories &&
            !hideLinks
          "
          to="/categories"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          data-id="categories"
          :class="{disabled: !authorized}"
          @click="setActive('categories')"
        >
          <span> Catégories </span>
          <div class="fallback">Catégories</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="isCompanyCpa && permissions.cpap_view_admin_console"
          to="/console"
          data-id="console"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('console')"
        >
          <span> Dossiers </span>
          <div class="fallback">Dossiers</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <router-link
          v-if="isCompanyCpa && permissions.cpap_view_admin_console"
          to="/users"
          data-id="users"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('users')"
        >
          <span> Équipe du cabinet </span>
          <div class="fallback">Équipe du cabinet</div>
        </router-link>
        <router-link
          v-if="isCompanyCpa && permissions.cpap_cpa_company_access"
          to="/cabinet"
          data-id="cabinet"
          :style="dynamicLinkStyle"
          class="translate fy-mh-item"
          :class="{disabled: !authorized}"
          @click="setActive('cabinet')"
        >
          <span> Cabinet </span>
          <div class="fallback">Cabinet</div>
          <div
            v-show="!menuShown"
            class="fy-mh-slider"
          />
        </router-link>
        <div
          v-show="
            isActiveForCurrentCompany ||
            !companyList ||
            !Object.entries(companyList).length
          "
          :style="dynamicLinkStyle"
          :class="{
            'fy-mh-item': true,
            clickable: true,
            'router-link-active': menuActive,
            disabled: !authorized,
          }"
          @mousedown="showPopup"
        >
          <div class="user-btn clickable">
            <i class="fi-people" />
            <div class="fy-mh-slider" />
          </div>
          <FontAwesomeIcon
            v-if="hasBanksErrors() && permissions.bank_management"
            icon="circle"
            class="attention-dot"
          />
        </div>
        <div
          v-if="indicatorStyle"
          class="menu-indicator"
          :style="indicatorStyle"
        ></div>
      </div>
    </div>
    <LocalesSwitcher :class="{mobile}" />
    <CategoriesDropdownRectangle
      v-if="companiesDD"
      class="menu-header-dropdown"
      :adder="
        isCpaUser(activeUser) ? 'Ajouter un dossier' : 'Ajouter une entreprise'
      "
      :disable-adding="
        isCpaUser(activeUser) && !permissions.cpap_create_managed_company
      "
      :event-container="companiesDD"
      :list="listOfCompanies"
      :max-level="isCpaUser(activeUser) ? 2 : 1"
      :max-select-level="isCpaUser(activeUser) ? 2 : 1"
      :exclude-translation="true"
      no-sticky-head
      variable
      @add-element="localShowCreateCompany"
      @close="companiesDD = null"
      @select="
        switchCompany($event, $route.name);
        companiesDD = null;
      "
      @custom-select="
        switchCompany($event, $route.name, 'console');
        companiesDD = null;
      "
    />
    <Popup
      mode="menu"
      :show="menuShown && authorized && !mobile"
      keep-scroll
      @close="menuShown = false"
    >
      <UserMenu
        ref="menu"
        @close="menuShown = false"
        @create-company="localShowCreateCompany"
        @logout="
          menuShown = false;
          companyList = {};
          init();
        "
        @show-add-bank-popup="$emit('showAddBankPopup')"
        @show-confirm-delete-bank="localShowDeleteConfirmBank"
        @show-confirm-delete-company="localShowDeleteConfirmCompany"
        @show-confirm-delete-partner-integration="
          localShowDeleteConfirmIntegration
        "
        @show-funding="redirectToFinancement()"
      />
    </Popup>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import {mapActions, mapGetters, mapState} from 'vuex';
import {companyMixin} from '@/mixins/companyMixin';
import {formatMixin} from '@/mixins/formatMixin';
import {cpaMixin} from '@/mixins/cpaMixin';
import {rolesChecker} from '@/mixins/rolemixin';
import {pagesChecker} from '@/mixins/pagesCheckerMixin';
import {defineAsyncComponent, nextTick} from 'vue';
import roles from '@/data/roles/index';
import en from '@/data/tracking/index';
import UserMenu from '@/components/widgets/UserMenu.vue';
import CategoriesDropdownRectangle from '@/components/elements/CategoriesDropdownRectangle.vue';

export default {
  name: 'MainHeader',
  components: {
    UserMenu,
    CategoriesDropdownRectangle,
    LocalesSwitcher: defineAsyncComponent(
      () => import('@/components/elements/LocalesSwitcher.vue'),
    ),
    MobileHeaderDropdown: defineAsyncComponent(
      () => import('@/components/elements/MobileHeaderDropdown.vue'),
    ),
  },
  mixins: [companyMixin, formatMixin, cpaMixin, rolesChecker, pagesChecker],
  props: {
    showCreateCompany: {
      type: Function,
      default: () => '',
    },
    showConfirmDeleteBank: {
      type: Function,
      default: () => '',
    },
    showConfirmDeleteCompany: {
      type: Function,
      default: () => '',
    },
    showConfirmDeleteIntegration: {
      type: Function,
      default: () => '',
    },
    mobile: Boolean,
  },
  emits: ['showAddBankPopup'],
  data() {
    return {
      companiesDD: null,
      indicatorStyle: {
        width: 0,
        transform: 'translateX(60vw)',
      },
      subscribeText: "M'abonner",
      remainingDaysText: 'jours gratuits restants',
      sales_gr: roles.SALES_GROUP_ROLE,
      admin_gr: roles.ADMIN_GROUP_ROLE,
      bubbleTop: 0,
      bubbleLeft: 0,
      bubbleShown: false,
      dropdownTop: 0,
      dropdownBottom: 0,
      dropdownLeft: 0,
      dropdownRight: 0,
      menuShown: false,
      mobileDropdownOpened: false,
      searchCompany: '',
      disappearing: false,
      companyList: {},
      selectingUser: null,
      smallTrialButton: false,
      observer: null,
      userEmail: '',
      usersList: [],
      retryCount: 0,
    };
  },
  computed: {
    ...mapState('app', [
      'loading',
      'reloading',
      'tooManyConnections',
      'scaleRatio',
    ]),
    ...mapState('bank', ['banks']),
    ...mapState('company', [
      'appHeaderBgColor',
      'appLogo',
      'appMenuTextColor',
      'appMenuTextColorOnHover',
      'appMenuTextColorSelected',
    ]),
    ...mapState('user', [
      'authorized',
      'user',
      'permissions',
      'companies',
      'isActiveForCurrentCompany',
      'invoicesAllowed',
      'checksAllowed',
      'bankConnections',
      'isCompanyCpa',
      'isStandalone',
    ]),
    ...mapState('subscription', [
      'subscription',
      'showTrial',
      'showTrialButton',
    ]),
    ...mapGetters('user', ['activeUser']),
    menuActive() {
      return (
        this.menuShown ||
        ['profile', 'admin'].includes(this.$route.name) ||
        (['users', 'company'].includes(this.$route.name) &&
          !this.isCompanyCpa &&
          !this.mobile)
      );
    },
    dynamicLinkStyle() {
      return {
        '--color': `#${this.appMenuTextColor || (this.mobile ? 'FFFFFF' : 'BFC8E1')}`,
        '--color-selected': `#${
          this.appMenuTextColorSelected || (this.mobile ? '30CE8F' : 'FFFFFF')
        }`,
        '--color-hover': `#${this.appMenuTextColorOnHover || 'F5F6FE'}`,
      };
    },
    currentCompany() {
      if (this.checkNotAuthenticatedPages(this.$route.name)) return '';
      return this.companyList[this.companyId]
        ? this.companyList[this.companyId]
        : [];
    },
    companyId() {
      if (this.checkNotAuthenticatedPages(this.$route.name)) return '';
      return localStorage.getItem('FYGR_COMPANY');
    },

    displayedUsers() {
      return this.usersList.map((u) => ({
        id: u.id,
        name: `${u.role === 'CpaRole' ? '[CPA] ' : ''}${u.email}${u.is_active ? '' : ' - inactive'}`,
      }));
    },
    hideLinks() {
      return (
        !this.subscription.has_subscription &&
        !this.subscription.trial &&
        !this.isStandalone &&
        !this.isCpaUser(this.activeUser) &&
        !this.subscription.default
      );
    },

    remainingDays() {
      return this.subscription ? this.subscription.remaining_days : 0;
    },
    trialPeriodButtonVisibility() {
      return (
        !this.checkNotAdminAndNotAuthenticatedPages(this.$route.name) &&
        this.subscription &&
        ((this.remainingDays >= 0 && this.subscription.trial) ||
          this.subscription.default) &&
        this.showTrialButton === true
      );
    },
    endTrialPeriodButtonVisibility() {
      return (
        !this.checkNotAdminAndNotAuthenticatedPages(this.$route.name) &&
        this.subscription &&
        this.showTrialButton === true &&
        this.subscription.has_subscription === false
      );
    },
    displayedTrialButton() {
      return (
        this.isActiveForCurrentCompany &&
        this.trialPeriodButtonVisibility &&
        (this.isStandalone || this.isCpaUser(this.activeUser))
      );
    },
  },
  watch: {
    companies: {
      handler() {
        this.companyList = {...this.companies};
      },
      deep: true,
    },
    displayedTrialButton() {
      if (this.displayedTrialButton && !this.observer) {
        nextTick(() => {
          if (this.$refs.trial) {
            this.observer = new ResizeObserver((entries) => {
              entries.map((entry) => {
                this.smallTrialButton =
                  entry.borderBoxSize &&
                  entry.borderBoxSize[0] &&
                  entry.borderBoxSize[0].inlineSize < 162.5;
                return null;
              });
            });
            this.observer.observe(this.$refs.trial);
          }
        });
      }
    },
    '$route.name': {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.setActive();
          });
        }
      },
    },
  },
  beforeUnmount() {
    if (this.observer && typeof this.observer.disconnect === 'function') {
      this.observer.disconnect();
    }
  },
  async created() {
    if (this.$route.name === 'acceptInvite' && this.$route.query.token) {
      const jwt = jwtDecode(this.$route.query.token);
      await this.actionGetStyles({companyId: jwt.companyId});
    }
    if (
      this.$route.query.iscpa === 'true' &&
      this.$route.query.partner_id &&
      this.$route.query.puk
    ) {
      const re = /[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9]+/;
      if (this.$route.query.puk.match(re)) {
        await this.actionGetStyles({partner_id: this.$route.query.partner_id});
      }
    }
  },
  async mounted() {
    this.userEmail =
      this.activeUser?.email && this.activeUser?.email !== this.user?.email
        ? this.activeUser.email
        : '';
    if (this.authorized) {
      this.companyList = await this.actionGetCompaniesList();
    }
    this.subscribeText = await this.actionTranslatePhrase("M'abonner");
    this.remainingDaysText = await this.actionTranslatePhrase(
      'jours gratuits restants',
    );
    window.addEventListener('resize', this.setActive);
  },
  unmounted() {
    window.removeEventListener('resize', this.setActive);
  },
  methods: {
    ...mapActions('translations', ['actionTranslatePhrase']),
    ...mapActions('user', [
      'actionPretend',
      'actionGetUserProfile',
      'actionGetDefaultCurrency',
      'actionGetCompaniesList',
      'actionGetPermissions',
      'actionGetUsersList',
      'actionLogout',
    ]),
    ...mapActions('subscription', [
      'actionChangeShowTrial',
      'actionChangeShowTrialButton',
    ]),
    ...mapActions('bank', [
      'actionGetBanksAndAccountsList',
      'actionLoadTransactions',
      'actionUnauthBanks',
    ]),
    ...mapActions('company', ['actionGetStyles']),
    ...mapActions('app', ['actionAddNotification']),
    ...mapActions('tracking', ['actionUpdateHubSpotObject']),
    setActive(name) {
      if (this.mobile) {
        return;
      }
      const items = Array.from(this.$el.querySelectorAll('.fy-mh-item'));
      const targetItem = items.find(
        (item) => item.getAttribute('data-id') === name,
      );
      const activeItem = items.find((item) =>
        item.classList.contains('router-link-active'),
      );
      const itm = targetItem || activeItem;
      if (!itm) {
        return;
      }
      const {offsetWidth, offsetLeft} = itm;

      // as we draw menu items with a lot of conditions depending on different params
      // we should set styles when all items are mounted and present

      if (offsetWidth === 0 && offsetLeft === 0) {
        if (this.retryCount < 30) {
          this.retryCount++;
          setTimeout(() => this.setActive(), 200);
        }
        return;
      }
      this.indicatorStyle = {
        width: `${offsetWidth + 4}px`,
        transform: `translateX(${offsetLeft - 2}px)`,
      };
      this.retryCount = 0;
    },
    async getFilteredUsers(e) {
      if (e.length > 4) {
        this.usersList = await this.actionGetUsersList({search: e});
      }
    },
    openChat() {
      if (window.Intercom) {
        window.Intercom('show');
      }
    },
    showBubble(e, show, fixY) {
      this.bubbleTop = e.clientY - e.offsetY - fixY;
      this.bubbleLeft = e.clientX - e.offsetX + 30;
      this.bubbleShown = show;
    },
    startSelectingUser(e) {
      this.getFilteredUsers(this.userEmail);
      this.selectingUser = {
        e,
        container: '.drop-top',
        style: {
          hh: 30 / this.scaleRatio,
          'min-width': 300 / this.scaleRatio,
          'max-width': 300 / this.scaleRatio,
        },
      };
    },
    pretendUser(id) {
      const user = this.usersList.find((u) => u.id === id[0]);
      this.actionPretend({user});
      this.selectingUser = null;
    },
    localShowCreateCompany() {
      this.menuShown = false;
      this.companiesDD = null;
      this.mobileDropdownOpened = false;
      this.showCreateCompany();
    },
    localShowDeleteConfirmCompany(id) {
      this.idToDelete = id;
      this.menuShown = false;
      this.showConfirmDeleteCompany(id);
    },
    localShowDeleteConfirmBank(id) {
      this.idToDelete = id;
      this.menuShown = false;
      this.showConfirmDeleteBank(id);
    },
    localShowDeleteConfirmIntegration(partnerIntegration) {
      this.menuShown = false;
      this.showConfirmDeleteIntegration(partnerIntegration);
    },
    showHideTrialLayoutAction() {
      // two cases :
      // if i'am in trial, i can hide/show
      // if not can't change status
      if (this.subscription) {
        if (this.subscription.has_subscription) {
          this.showTrial = false;
        } else if (this.subscription.trial === true) {
          this.actionChangeShowTrial();
        } else {
          this.actionChangeShowTrial(true);
        }
      }
      /* HubSpot tracking so that we detect when people have clicked on the button */
      this.actionUpdateHubSpotObject({
        HSObj: {
          type: 'deal',
          properties: {
            proactive_click_on_subscription_button: JSON.stringify({
              date: Date(),
            }),
          },
        },
      });
      window.analytics.track(en.EN_PROACTIVE_SUBSCRIPTION_BUTTON_CLICKED.name, {
        ...en.EN_PROACTIVE_SUBSCRIPTION_BUTTON_CLICKED.properties,
        email: this.user.email,
      });
      // Do nothing
    },
    redirectToFinancement() {
      // HubSpot: dedicated stream
      this.actionUpdateHubSpotObject({
        HSObj: {
          type: 'deal',
          properties: {
            click_on_funding_button: JSON.stringify({
              date: Date(),
            }),
          },
        },
      });
      // Segment / Mixpanel and other
      window.analytics.track(en.EN_FUNDING_BUTTON_CLICKED.name, {
        ...en.EN_FUNDING_BUTTON_CLICKED.properties,
        email: this.user.email,
      });
      this.menuShown = false;
      window.open('https://financing.fygr.io/application', '_blank');
    },
    openDropdown(e) {
      this.companiesDD = {
        e,
        container: '.drop-top',
        style: {
          hh: 30 / this.scaleRatio,
          'min-width': 300 / this.scaleRatio,
          'max-width': 300 / this.scaleRatio,
        },
      };
    },
    async reloadTransactions() {
      if (this.banks && this.banks.length > 0) {
        this.showUpdateTransactionsPopup();
        await this.actionLoadTransactions();
      }
    },
    showPopup() {
      if (!this.menuShown) {
        this.menuShown = true;
      }
      if (this.mobile && this.menuShown && this.mobileDropdownOpened) {
        this.$refs.mhd.close();
      }
    },
    showUpdateTransactionsPopup() {
      this.actionAddNotification({
        msg: "Nous sommes en train d'actualiser vos données bancaires. Cette opération peut prendre quelques minutes.",
        color: 'gray',
        disappearing: true,
        once: true,
      });
    },
    hasBanksErrors() {
      const banks = this.banks
        ? this.banks.map((b) => b.state.status === 'error')
        : [true];
      return banks.includes(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

.fy-mh-mobile-companies {
  display: flex;
  flex-direction: column;
  width: 100%;
  .fy-mh-mobile-companies-search[class] {
    width: 100%;
    font-size: 16px;
    :deep(svg) {
      font-size: 20px;
      top: calc(50% - 10px);
    }
    :deep(input[class]) {
      font-size: 16px;
      max-height: 44px;
      min-height: 44px;
      padding-left: 60px;
      width: calc(100% - 105px);
    }
  }
  .fy-mh-mobile-company-list {
    display: flex;
    flex-direction: column;
    overflow: auto;
    max-height: calc(100% - 97px);
    margin-top: 15px;
    margin-right: -10px;
    &.no-adder {
      max-height: calc(100% - 60px);
    }
  }
  .fy-mh-mobile-company-adder {
    display: flex;
    font-size: 16px;
    font-weight: 600;
    color: white;
    margin-top: 15px;
    align-items: center;
    align-self: flex-end;
    svg {
      margin-right: 10px;
    }
  }
  .fy-mh-mobile-company {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 10px;
    .fy-mh-mobile-company-name {
      display: flex;
      align-items: center;
      color: white;
      margin: 15px 0;
      font-size: 16px;
      opacity: 0.8;
      &.active {
        opacity: 1;
        font-weight: 600;
      }
      &.red {
        color: $red;
      }
      i {
        margin-right: 10px;
      }
    }
    .fy-mh-mobile-company-separator {
      min-width: 64px;
      min-height: 2px;
      background-color: $green;
      border-radius: 1px;
    }
  }
}
.speech-bubble {
  padding: var(--px10);
}
.speech-bubble:after {
  left: 0;
  top: 50%;
  border: var(--px5) solid transparent;
  border-right-color: white;
  border-left: 0;
  margin-top: var(--px-5);
}
.header-container {
  height: $header-height-var;
  z-index: 999;
  &.unauth {
    height: $header-height-var;
  }
  &.mobile {
    max-height: 66px;
    min-height: 66px;
    height: 66px;
    &.unauth {
      height: $header-height-var;
      max-height: $header-height-var;
      min-height: $header-height-var;
    }
  }
  .locales-wrap {
    z-index: 9999;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.users-dd[class] {
  z-index: 126;
}
.users-input {
  margin-right: var(--px20);
  :deep(svg) {
    font-size: var(--px14);
    left: var(--px15);
    top: calc(50% - var(--px7));
  }
  :deep(input) {
    max-height: var(--px28);
    min-height: var(--px28);
    font-size: var(--px14);
    padding: 0 var(--px45);
    width: calc(100% - var(--px90));
  }
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  max-height: $header-height-var;
  min-height: $header-height-var;
  width: 100%;
  background-color: $header;
  display: flex;
  z-index: 10;
  justify-content: space-between;
  &.unauth {
    max-height: $header-height-var;
    min-height: $header-height-var;
    .logo .fy-mh-fygr-logo[class] {
      min-height: var(--px54);
      max-height: var(--px54);
    }
  }
  &.mobile {
    height: 66px;
    max-height: 66px;
    min-height: 66px;
    z-index: 108;
    &.unauth {
      height: $header-height-var;
      max-height: $header-height-var;
      min-height: $header-height-var;
    }
  }
  a {
    display: flex;
    flex: 1;
  }
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100% - var(--px20));
    margin: 0 var(--px50);
    padding: var(--px10) 0 var(--px15);
    &.unauth {
      padding: var(--px10) 0;
      margin-left: var(--px51);
    }
    &:not(.small) {
      flex: 1;
    }
    &.small {
      max-width: var(--px150);
    }
    &.mobile {
      margin: 0 20px;
      padding: 0;
      margin-bottom: 2px;
      &.unauth {
        margin: auto;
      }
      &.appLogo {
        margin-bottom: auto;
      }
    }
    .max-height-logo[class] {
      width: 100%;
      height: auto;
      max-height: var(--px54);
      max-width: var(--px150);
    }
    .router-link-active {
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .fy-mh-fygr-logo {
        min-height: var(--px54);
        max-height: var(--px54);
      }
    }
  }
  .fy-mh-menu {
    text-decoration: none;
    display: flex;
    min-height: 100%;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    padding-right: 34px;
    &.mobile {
      margin-bottom: 15px;
      margin-top: auto;
      align-items: center;
      .fy-mh-item {
        margin-right: 20px;
      }
    }
    .fy-mh-mobile-company-picker {
      display: flex;
      align-items: center;
      color: white;
      margin-right: 30px;
      &.opened {
        svg {
          transform: rotate(180deg);
          transition: transform 0.3s;
        }
      }
      .fy-mh-mobile-company-picker-text {
        margin-right: 15px;
        max-width: 145px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        height: 18px;
        font-weight: 600;
      }
      svg {
        font-size: 22px;
        transform: rotate(0deg);
        transition: transform 0.3s;
      }
    }
    .fy-mh-item {
      display: flex;
      height: 100%;
      text-decoration: none;
      user-select: none;
      align-items: center;
      flex: 0;
      @extend %text-font;
      opacity: 0.8;
      white-space: nowrap;
      color: var(--color);
      margin-right: var(--px60);
      position: relative;
      .fallback {
        visibility: hidden;
        font-weight: 600;
      }
      span {
        position: absolute;
      }
      .fy-mh-slider {
        display: none;
        position: absolute;
        width: calc(100% + var(--px20));
        height: var(--px5);
        left: var(--px-10);
        bottom: 0;
        background: $green;
        border-radius: var(--px8) var(--px8) 0px 0px;
      }
      &:hover {
        color: var(--color-hover);
      }
      &.router-link-active {
        opacity: 1;
        color: var(--color-selected);
        font-weight: 600;
        transition: 0.15s;
      }
      &.disabled {
        color: var(--color);
        pointer-events: none;
      }
      .attention-dot[class] {
        position: absolute;
        top: var(--px22);
        right: -2px;
        color: $red;
        font-size: var(--px5);
      }
    }
  }
}

//.fy-mh-menu .fy-mh-item::after {
//  content: '';
//  height: var(--px5);
//  position: absolute;
//  bottom: 0;
//  transition: 0.3s all 0.025s;
//  left: calc(100% + var(--px10));
//  right: var(--px-10);
//  transition-delay: 0s;
//  background: $green;
//  border-radius: var(--px5) var(--px5) 0 0;
//}

//.fy-mh-menu .fy-mh-item.router-link-active:not(.mobile)::after {
//  left: var(--px-10);
//  right: var(--px-10);
//  transition-delay: 0.1s;
//}
//
//.fy-mh-menu .fy-mh-item.router-link-active:not(.mobile) ~ .fy-mh-item::after {
//  left: var(--px-10);
//  right: calc(100% + var(--px10));
//  transition-delay: 0.2s;
//}

.disappearing {
  .content {
    animation: collapseY 0.25s;
  }
}
.dropdown {
  z-index: 100;
  position: fixed;
  display: flex;
  flex-direction: column;

  &.reverse {
    flex-direction: column-reverse;
  }
  .head {
    z-index: 102;
    min-width: 180px;
    max-width: 180px;
    height: 30px;
    background-color: white;
    position: relative;
    cursor: pointer;
    display: flex;
    padding: 0 5px 0 15px;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px 10px 0 0;
    -webkit-box-shadow: 0 -6px 18px -10px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0 -6px 18px -10px rgba(0, 0, 0, 0.25);
    box-shadow: 0 -6px 18px -10px rgba(0, 0, 0, 0.25);
    i {
      transform: scaleY(-1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: $gray;
    }
  }
  .head:after {
    content: '';
    width: 40px;
    height: 20px;
    border: 4px solid white;
    position: absolute;
    bottom: -4px;
    border-top: 0;
    border-right: 0;
    border-radius: 0 0 0 12px;
    right: -40px;
  }
  .content {
    z-index: 99;
    width: 270px;
    background-color: white;
    padding-top: 10px;
    border-radius: 0 10px 10px 10px;
    -webkit-box-shadow: 2px 2px 20px -5px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 2px 2px 20px -5px rgba(0, 0, 0, 0.25);
    box-shadow: 2px 2px 20px -5px rgba(0, 0, 0, 0.25);
    .items {
      max-height: 200px;
      overflow: auto;
      padding-bottom: 10px;
      .item {
        cursor: pointer;
        text-align: left;
        height: 20px;
        padding: 10px 20px;
        position: relative;
        &:hover {
          background-color: $blue;
          color: white;
          .separator {
            background-color: $blue;
          }
        }
        .separator {
          height: 1px;
          background-color: $bg;
          position: absolute;
          bottom: 0;
          width: 230px;
          left: 20px;
          margin-top: 10px;
        }
      }
    }
  }
}
i {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--px18);
}
.user-btn {
  width: var(--px20);
  height: var(--px20);
  i {
    font-size: var(--px18);
  }
  &.white {
    width: 30px;
    height: 30px;
    i {
      font-size: 30px;
    }
  }
}
.selector {
  height: var(--px30);
  margin-right: var(--px20);
  background-color: white;
  outline: none;
  border-radius: var(--px10);
  padding: 0 var(--px10);
  width: var(--px200);
}
.sync {
  margin-right: var(--px60);
  font-size: var(--px14);
  color: var(--color);
  &:not(.clickable) {
    color: var(--color);
    opacity: 60%;
  }
}
.trial-button {
  width: var(--px190);
  height: var(--px40);
  border: 0;
  border-radius: var(--px8);
  color: white;
  font-size: var(--px13);
  text-transform: uppercase;
  background: linear-gradient(0.25turn, #3af693, #00cc7e);
  margin-right: var(--px20);

  &:focus {
    outline: 0;
  }

  .remainings {
    font-size: var(--px10);
  }

  &.hovarable:hover {
    background: color.adjust(#3af693, $lightness: 10%);
  }
}
.drop-top {
  background-color: $bg;
  min-width: var(--px184);
  max-width: var(--px184);
  height: var(--px30);
  display: flex;
  padding: 0 var(--px5) 0 var(--px15);
  align-items: center;
  border-radius: var(--px8);
  margin-right: var(--px20);
  font-size: var(--px14);
  justify-content: space-between;
  &.user {
    color: $text-color-gray;
  }
  .short-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: var(--px152);
  }
  svg {
    margin: 0 var(--px10) 0 0;
    color: $gray;
    transition: transform 0.25s ease;
    &.open {
      transform: rotate(180deg);
    }
  }
}
.adder {
  padding: var(--px20);
  padding-top: var(--px10);
  text-align: center;
  .clickable:hover {
    color: rgba($blue, 0.75);
  }
}

.menu-header-dropdown[class] {
  z-index: 126;
}

.label-full {
  width: 100%;
  margin-top: var(--px5);
  :deep(input) {
    font-size: var(--px14);
    max-height: var(--px38);
    min-height: var(--px38);
    width: calc(100% - var(--px30));
    padding: 0 var(--px15);
  }
}
.funding-bloc-fygr {
  width: 100%;

  .funding-bloc-fygr-text-block {
    display: inline-block;
  }
  .funding-bloc-fygr-url-block {
    display: inline-block;
    font-size: var(--px14);

    .url-clickable {
      font-size: var(--px14);
    }
  }
}
.funding-bloc-partner {
  text-align: justify;

  .fygr-v-partner {
    width: 100%;
  }
  .fygr-v-partner-fyve {
    width: 50%;
    display: block;
    margin: 0 auto;
  }
}
.menu-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  content: '';
  height: var(--px5);
  transition: 0.35s all 0.025s;
  right: var(--px-10);
  transition-delay: 0s;
  background: $green;
  border-radius: var(--px5) var(--px5) 0 0;
}
@media only screen and (max-width: 1520px) {
  .header .fy-mh-menu .fy-mh-item {
    margin-right: var(--px45);
  }
}
@media only screen and (max-width: 1425px) {
  .header .fy-mh-menu .fy-mh-item {
    margin-right: var(--px35);
  }
  .sync {
    margin-right: var(--px50);
  }
}
@media only screen and (max-width: 1365px) {
  .header .fy-mh-menu .fy-mh-item {
    margin-right: var(--px25);
  }
  .drop-top {
    max-width: var(--px150);
    min-width: var(--px150);
  }
  .sync {
    margin-right: var(--px30);
  }
  .header .logo {
    margin: 0 var(--px20) 0 var(--px30);
  }
}
</style>
